module.exports = __webpack_public_path__ + "static/img/zeta_template_02.46016e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeta_template_02.png
// module id = Rjd9
// module chunks = 1